import types from '../types/shared'
import {Map} from 'immutable'
import queryString from 'querystring'

const initialRoot = Map({
  tab: 'withMe',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_TAB:
      return state.set('tab', action.payload.tab)
    case '@@router/LOCATION_CHANGE':
      const payload = action.payload
      if (payload.pathname !== '/compartido') return state
      const parsed = queryString.parse(payload.search.substr(1, payload.search.length))
      if (!parsed['con'] || (parsed['con'] !== 'migo' && parsed['con'] !== 'otros')) return state
      switch (parsed['con']) {
        case 'migo':
          return state.set('tab', 'withMe')
        case 'otros':
          return state.set('tab', 'withOthers')
        default:
          return state.set('tab', 'withMe')
      }
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/shared/reducers/shared.js